import http, { apiErrorMessage } from '../../http';

const vRutaMonitoreo = 'monitoreo/';

export const getListForTable = (fecha,sucursal) => {
    return (dispatch, getState) => {
        http.get(vRutaMonitoreo + 'repartos-sucursal', { params: { sucursal, fecha } })
            .then(function (response) {
                // Envelope v1 dataTable: {data:{rows:[...]}} -> la vista espera {data:[...]}
                dispatch({
                    type: "MONITOREO_LIST_SUCCESS", payload: {
                        data: { data: response.data.data.rows },
                    }
                });
            })
            .catch(function (error) {
                dispatch({ type: 'MONITOREO_LIST_ERROR', payload: { error: apiErrorMessage(error) } });
            })
            .finally(function () {
                //dispatch({ type: 'HIDE_LOADING' });
            });
    }
}

export const f_ObtenerRepartos = (sucursal,fecha) => {
    return (dispatch, getState) => {

        dispatch({ type: 'SHOW_LOADING' });

        http.get(vRutaMonitoreo + 'repartos', { params: { sucursal, fecha } })
            .then(function (response) {
                // Envelope v1: {data:{repartos,totales,detallerepartos}} -> la vista lee .resultado
                dispatch({
                    type: "MONITOREO_OBTENER_REPARTOS", payload: {
                        data: { resultado: response.data.data },
                    }
                });
            })
            .catch(function (error) {
                dispatch({ type: 'MONITOREO_LIST_ERROR', payload: { error: apiErrorMessage(error) } });
            })
            .finally(function () {
                //dispatch({ type: 'HIDE_LOADING' });
            }
        );
    }
}
// idreparto,folioreparto,guia
export const f_ObtenerReparto = (unidad,sucursal,fecha,guia) => {
    return (dispatch, getState) => {

        dispatch({ type: 'SHOW_LOADING' });

        http.get(vRutaMonitoreo + 'reparto', { params: { unidad, sucursal, fecha, guia } })
            .then(function (response) {
                // Envelope v1: {data:{reparto,detalle,mapa,...}} -> la vista lee .resultado
                dispatch({
                    type: "MONITOREO_OBTENER_REPARTO", payload: {
                        data: { resultado: response.data.data },
                    }
                });
            })
            .catch(function (error) {
                dispatch({ type: 'MONITOREO_LIST_ERROR', payload: { error: apiErrorMessage(error) } });
            })
            .finally(function () {
                //dispatch({ type: 'HIDE_LOADING' });
            }
        );
    }
}

export const ObtenerInformacionGuia = (guia) => {
    return (dispatch, getState) => {

        dispatch({ type: 'SHOW_LOADING' });

        http.get(vRutaMonitoreo + 'guias/' + encodeURIComponent(guia))
            .then(function (response) {
                // Envelope v1: {data:{datos,...}} -> la vista lee .resultado.datos
                dispatch({
                    type: "MONITOREO_OBTENER_GUIA", payload: {
                        data: { resultado: response.data.data },
                    }
                });
            })
            .catch(function (error) {
                dispatch({ type: 'MONITOREO_LIST_ERROR', payload: { error: apiErrorMessage(error) } });
            })
            .finally(function () {
                //dispatch({ type: 'HIDE_LOADING' });
            }
        );
    }
}

export const f_ObtenerRecoleccionesUnidad = (sucursal,fecha) => {
    return (dispatch, getState) => {
        http.get('recolecciones/por-unidad', { params: { sucursal, fecha } })
            .then(function (response) {
                // Envelope v1: {data:[{unidad,asignadas,recolectadas,fallidas,pendientes,porcentaje}]}
                dispatch({
                    type: "MONITOREO_OBTENER_RECOLECCIONES", payload: {
                        data: { resultado: response.data.data },
                    }
                });
            })
            .catch(function () {
                // Carga secundaria: si falla solo se omiten los circulos de
                // recolecciones; no debe tumbar la vista principal de repartos.
                dispatch({ type: 'MONITOREO_RECOLECCIONES_ERROR' });
            });
    }
}

export const f_ObtenerTotalesRecolecciones = (sucursal,fecha) => {
    return (dispatch, getState) => {
        http.get('recolecciones/totales', { params: { sucursal, fecha } })
            .then(function (response) {
                // Envelope v1: {data:{canceladas,transmitidas,realizadas}} (campos null sin datos)
                dispatch({
                    type: "MONITOREO_OBTENER_RECOLECCIONES_TOTALES", payload: {
                        data: { resultado: response.data.data },
                    }
                });
            })
            .catch(function () {
                // Carga secundaria: si falla solo se omite la card de totales.
                dispatch({ type: 'MONITOREO_RECOLECCIONES_TOTALES_ERROR' });
            });
    }
}

export const f_ObtenerRecoleccionesDetalle = (sucursal,fecha) => {
    return (dispatch, getState) => {
        http.get('recolecciones', { params: { sucursal, fecha, estado: 'todas', recolecciones: 'si' } })
            .then(function (response) {
                // Envelope v1 dataTable: {data:{rows:[{id,folio,fecha,estado,unidad,cliente}]}}
                dispatch({
                    type: "MONITOREO_OBTENER_RECOLECCIONES_DETALLE", payload: {
                        data: { resultado: response.data.data.rows },
                    }
                });
            })
            .catch(function () {
                // Carga secundaria: si falla solo se omite el detalle expandible.
                dispatch({ type: 'MONITOREO_RECOLECCIONES_DETALLE_ERROR' });
            });
    }
}

export const f_LimpiarReparto = () => {
    return (dispatch, getState) => {
        dispatch({type: "MONITOREO_LIMPIAR_REPARTO"});
    }
}

export const closeMessages = () => {
    return (dispatch, getState) => {
        dispatch({type: "MONITOREO_CLOSE_MESSAGES"});
    }
}
